<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      initialValues: {
        title_pl: 'Newsletter',
        button_text_pl: 'Zapisz się do nas'
      }
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'Tekst na przycisku',
              modelPath: [this, 'form', 'button_text'],
              multilingual: true,
              required: true
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              required: true
            }),
            new fields.Input({
              label: 'Informacja',
              type: 'textarea',
              modelPath: [this, 'form', 'info'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Podziękowania',
              modelPath: [this, 'form', 'summary'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
